import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {Collapser} from "./collapser"

export const collapserLoader = function (options = {}) {
    componentLoader(componentConfig(Collapser, Collapser.config.componentTypeKey, Collapser.config.baseHtmlClass), options);
};

